import { createSelector } from 'reselect';

import { State } from './reducer';

export const selectData = (state: any) => state.currency;

export const getAll = createSelector(
  [selectData],
  (state: State) => state.items,
);

export const getActive = createSelector(
  [selectData],
  (state: State) => state.activeItem,
);
